import { render, staticRenderFns } from "./PatrimonioTab.vue?vue&type=template&id=22dca7c0"
import script from "./PatrimonioTab.vue?vue&type=script&lang=js"
export * from "./PatrimonioTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports